import React from 'react';

import {
  PersonalInfoFormValues,
  PersonalInfoFormViolation,
} from 'types/personalInfoTypes';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { createPersonalFormViolationLense } from 'utils/validatePersonalInfoFormValues';
import { AsYouType } from 'libphonenumber-js';

export const usePersonalInfoFormValues = () => {
  const { personalInfoFormValues: values } = useAppState();

  const [violations, setViolations] = React.useState<
    PersonalInfoFormViolation[]
  >([]);

  const dispatch = useAppDispatcher();

  const setValues = React.useCallback(
    (nextValues: Partial<PersonalInfoFormValues>) => {
      dispatch({
        name: 'ProdStackManager__PersonalInfoFormValuesChanged',
        nextValues,
      });
    },
    [dispatch]
  );

  const changeFirstName = React.useCallback(
    (nextValue: string) => {
      setValues({
        firstName: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(violation).isFirstNameViolation()
        )
      );
    },
    [setValues]
  );

  const changeMiddleName = React.useCallback(
    (nextValue: string) => {
      setValues({
        middleName: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(violation).isMiddleNameViolation()
        )
      );
    },
    [setValues]
  );

  const changeLastName = React.useCallback(
    (nextValue: string) => {
      setValues({
        lastName: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(violation).isLastNameViolation()
        )
      );
    },
    [setValues]
  );

  const changePhone = React.useCallback(
    (nextValue: string) => {
      const nextValueFormatted = new AsYouType().input(nextValue);

      setValues({
        phone: nextValueFormatted,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(violation).isPhoneViolation()
        )
      );
    },
    [setValues]
  );

  const changePosition = React.useCallback(
    (nextValue: string) => {
      setValues({
        position: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(violation).isPositionViolation()
        )
      );
    },
    [setValues]
  );

  const changePartnerCode = React.useCallback(
    (nextValue: string[]) => {
      setValues({
        partnerCode: nextValue,
      });

      setViolations((prev) =>
        prev.filter(
          (violation) =>
            !createPersonalFormViolationLense(
              violation
            ).isPartnerCodeViolation()
        )
      );
    },
    [setValues]
  );

  return {
    values,
    violations,
    setValues,
    setViolations,
    changePartnerCode,
    changePosition,
    changePhone,
    changeMiddleName,
    changeLastName,
    changeFirstName,
  };
};
